import { c as _c } from "react/compiler-runtime";
import useScript from '@/hooks/useScript';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

/*
Wrapper for https://bbgithub.dev.bloomberg.com/WSS/projector/blob/master/documentation/EXAMPLES.md
*/

export enum IdType {
  AVMM = 'AVMM',
  BMMR = 'BMMR',
  LIVE = 'LIVE',
}

/**
 * A component to play BMMR, AVMM, or LIVE Bloomberg videos.
 */
export const BVideoPlayer = props => {
  const $ = _c(15);
  const ref = useRef(null);
  const [player, setPlayer] = useState(null);
  const [loaded, error] = useScript("https://assets.bwbx.io/s3/multimedia/projector/latest/bplayer.js");
  let t0;
  if ($[0] !== player) {
    t0 = () => {
      if (player && player.dispose) {
        player.dispose();
      }
    };
    $[0] = player;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const clearPlayer = t0;
  let t1;
  if ($[2] !== clearPlayer || $[3] !== loaded || $[4] !== props) {
    t1 = () => {
      if (ref.current && loaded && (window as any).BPlayer) {
        clearPlayer();
        const embedOptions = buildEmbedOptions(props);
        const player_0 = (window as any).BPlayer.create(ref.current, embedOptions);
        setPlayer(player_0);
        if (props.onFirstPlay) {
          let isFirstPlay = true;
          player_0.on("play", () => {
            if (isFirstPlay) {
              isFirstPlay = false;
              props.onFirstPlay();
            }
          });
        }
      }
      return clearPlayer;
    };
    $[2] = clearPlayer;
    $[3] = loaded;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== loaded || $[7] !== props.onFirstPlay || $[8] !== props.videoId || $[9] !== props.videoIdType) {
    t2 = [ref, loaded, props.videoId, props.videoIdType, props.onFirstPlay];
    $[6] = loaded;
    $[7] = props.onFirstPlay;
    $[8] = props.videoId;
    $[9] = props.videoIdType;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  let t3;
  if ($[11] !== error) {
    t3 = error && <h3>Error loading video player</h3>;
    $[11] = error;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <FullWidthDiv ref={ref}>{t3}</FullWidthDiv>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
const FullWidthDiv = styled.div`
    width: 100%;
`;
export const buildEmbedOptions = (props: IBVideoPlayerProps) => {
  return {
    id: props.videoId,
    idType: props.videoIdType,
    // Unused for Live anyway
    live: props.videoIdType === IdType.LIVE,
    autoplay: props.autoPlay === true,
    serverUrl: '//www.bloomberg.com/api/embed',
    module_ad_player: 'disabled',
    use_comscore: false,
    use_parsely: false,
    log_debug: false,
    use_youbora: false
  };
};
interface IBVideoPlayerProps {
  /** ID of the video or live stream */
  videoId: string;
  /** Type of the ID  */
  videoIdType: IdType;
  /** Flag whether to automatically play the video (muted) on player load */
  /** @default false */
  autoPlay?: boolean;
  onFirstPlay?: () => void;
}